import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20colorful%20digital%20art%20with%20pink%20and%20green%20gradient%20glass%20crystal%20spheres%20floating%20particles%20technology%20background%20vibrant%20colors%20transparent%20glossy%20surfaces%20modern%20IT%20aesthetic%20fresh%20peach%20tones%20emerald%20mint%20rose%20bokeh%20light%20effects%20ultra%20high%20quality%20artistic%20composition&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Peach hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        {/* Glass overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-pink-500/20 via-transparent to-emerald-500/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-10 pt-24">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-4 py-1.5 mb-8">
          <span className="text-sm">🍑</span>
          <span className="text-white text-xs font-medium tracking-wider">FRESH IT SOLUTIONS</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          フレッシュな発想で、<br />
          <span className="bg-gradient-to-r from-pink-300 via-rose-200 to-emerald-300 bg-clip-text text-transparent">
            ビジネスに新しい価値を
          </span>
        </h1>

        {/* Sub */}
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          システム開発からアプリ制作、広告運用まで<br className="hidden md:block" />
          中小企業・個人事業主様のデジタル化を総合サポート
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer bg-gradient-to-r from-pink-400 to-rose-500 text-white font-semibold px-8 py-3.5 rounded-full hover:opacity-90 transition-all duration-200 flex items-center gap-2 text-sm md:text-base"
          >
            <i className="ri-mail-send-line"></i>
            無料相談はこちら
          </Link>
          <Link
            to="/services"
            className="whitespace-nowrap cursor-pointer bg-white/20 backdrop-blur-sm border border-white/40 text-white font-semibold px-8 py-3.5 rounded-full hover:bg-white/30 transition-all duration-200 flex items-center gap-2 text-sm md:text-base"
          >
            サービスを見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/50 text-xs tracking-widest">SCROLL</span>
          <i className="ri-arrow-down-line text-white/50"></i>
        </div>
      </div>

      {/* Bottom glass card preview */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 mt-8 pb-12">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { icon: 'ri-code-s-slash-line', label: 'システム開発', color: 'text-emerald-300' },
            { icon: 'ri-smartphone-line', label: 'アプリ制作', color: 'text-pink-300' },
            { icon: 'ri-megaphone-line', label: 'ネット広告', color: 'text-emerald-300' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-white/10`}>
                <i className={`${item.icon} ${item.color} text-xl`}></i>
              </div>
              <span className="text-white font-medium text-sm">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
